import { Component } from '@angular/core';
// managers
import { DateTimeManager } from './../../manager/datetime.manager';
// services
import { Locale } from './../../service/locale.service';
import { DeliveryPrintService } from './delivery-print.service';

@Component({
  selector: 'app-modal-delivery-print',
  templateUrl: './modal-delivery-print.component.html',
  providers:
  [
    DeliveryPrintService
  ]
})
export class ModalDeliveryPrintComponent {

  public visible = false;
  public visibleAnimate = false;
  public prints = [];
  public delivery_number;

  constructor(private locale:   Locale,
              private dateTimeManager: DateTimeManager,
              private deliveryPrintService: DeliveryPrintService) {}

  getTerms() { return this.locale.getTerms(); }

  setPrints(values, delivery_number) {
    this.prints = values;
    this.delivery_number = delivery_number;
  }

  getPrints() {
    return this.prints;
  }

  show() {
    this.visible = true;
    setTimeout(() => {
      this.visibleAnimate = true;
    }, 100);
  }

  hide() {
    this.visibleAnimate = false;
    setTimeout(() => {
      this.visible = false;
    }, 100);
  }

  // Returns normalized date
  getNormalDate(value) {
    if (value !== null && value !== undefined) {
      const date = new Date(value);
      this.dateTimeManager.setDate(date);
      const text = this.dateTimeManager.ddmmyyyy('/');
      return text;
    } else {
      return '';
    }
  }

  printDelivery(deliveryNumber, printType) {
    this.deliveryPrintService.printDelivery(deliveryNumber, printType);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/MODAL-delivery-print/modal-delivery-print.component.ts